module.exports = __webpack_public_path__ + "static/media/girl3.fbe0ab8d.png";